import {
  CHECKOUT_JUST_DELETED_LAST_MESSAGE,
  CHECKOUT_RECEIVE_ADDRESSES,
  CHECKOUT_RECEIVE_CONFIGURE_ADDRESES,
  CHECKOUT_RESET_TO_DEFAULT_STATE,
  CHECKOUT_SHOW_MAYBE_PO_BOX_HELPER_TEXT,
  CHECKOUT_STORE_ADDRESS_ALERT_MSG,
  CLEAR_CHECKOUT_SUGGESTED_ADDRESSES,
  NEW_ADDRESS_PRIMARY,
  RECEIVE_FIELD_VALIDATION_ERRORS,
  RECEIVE_NEW_SHIPPING_FIELD,
  SET_CHECKOUT_ADDRESSES_LOADING,
  SET_CHECKOUT_SUGGESTED_ADDRESSES,
  SET_INVALID_ADDRESS_FIELDS,
  SET_SELECTED_SUGGESTED_ADDRESS,
  VALIDATE_ADDRESS_FIELDS
} from 'constants/reduxActions';
import { ADDRESS_FIELDS } from 'constants/formFields';
import { INVALID_ADDRESS } from 'constants/errorMessages';
import { getRequestFieldDetails, getRequestFieldError, pushErrorMessages } from 'reducers/checkout/common';

const newAddress = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  countryCode: 'US',
  fullName: '',
  postalCode: '',
  primaryVoiceNumber: '',
  stateOrRegion: ''
};

const defaultState = {
  new: newAddress,
  suggestedAddresses: {},
  saved: [],
  isLoaded: false,
  loadingMessage: '',
  isNewPrimary: true,
  invalidFields: []
};

export function addresses(state = defaultState, action = {}) {
  const {
    addressAlertMsg,
    data,
    fieldKey,
    fieldValue,
    hasInvalidAddress,
    invalidFields,
    isBilling,
    loadingMessage,
    isNewPrimary,
    requestExtraInformation,
    selectedAddressId,
    showPoBoxHelperText,
    suggestedAddresses,
    type
  } = action;

  switch (type) {
    case CHECKOUT_RECEIVE_CONFIGURE_ADDRESES: {
      const { allAddresses } = data;
      const { saved: stateSavedAddresses } = state;
      const savedAddresses = allAddresses && allAddresses.addresses
        ? allAddresses.addresses
        : stateSavedAddresses;

      let newState = {
        ...state,
        deletedLastAddress: false,
        addressAlertMsg: null,
        isLoaded: true,
        loadingMessage: '',
        saved: savedAddresses
      };

      if (!hasInvalidAddress) {
        newState = { ...newState, new: newAddress, invalidFields: [], isNewPrimary: true };
      }

      newState = updateDisplayForSuggestedAddresses(newState);
      return newState;
    }

    case CHECKOUT_SHOW_MAYBE_PO_BOX_HELPER_TEXT: {
      return { ...state, showPoBoxHelperText };
    }

    case CHECKOUT_JUST_DELETED_LAST_MESSAGE: {
      return { ...state, deletedLastAddress: true };
    }

    case SET_CHECKOUT_ADDRESSES_LOADING: {
      return { ...state, loadingMessage };
    }

    case CHECKOUT_STORE_ADDRESS_ALERT_MSG: {
      return { ...state, addressAlertMsg };
    }

    case NEW_ADDRESS_PRIMARY: {
      return { ...state, isNewPrimary };
    }

    case CLEAR_CHECKOUT_SUGGESTED_ADDRESSES: {
      return { ...state, suggestedAddresses: {} };
    }

    case SET_SELECTED_SUGGESTED_ADDRESS: {
      return { ...state, suggestedAddresses: { ...state.suggestedAddresses, selectedAddressId } };
    }

    case SET_INVALID_ADDRESS_FIELDS: {
      let { new: newAddress } = state;
      (invalidFields || []).forEach(fieldError => {
        const { form, formField } = getRequestFieldDetails(fieldError.fieldName);
        if (form === 'address') {
          const addressErrors = newAddress.errors ? newAddress.errors : {};
          // canned error so we can hide it from display
          newAddress = { ...newAddress, errors: { ...addressErrors, [formField.fieldName]: [INVALID_ADDRESS] } };
        }
      });

      return { ...state, new: newAddress, invalidFields };
    }

    case RECEIVE_FIELD_VALIDATION_ERRORS:
    {
      let { new: newAddress } = state;
      requestExtraInformation.forEach(fieldError => {
        const { form, formField } = getRequestFieldDetails(fieldError.fieldName);
        if (form === 'address') {
          const errorMessage = getRequestFieldError(fieldError.id);
          const addressErrors = newAddress.errors ? newAddress.errors : {};
          newAddress = { ...newAddress, errors: { ...addressErrors, [formField.fieldName]: [errorMessage] } };
        }
      });

      return { ...state, new: newAddress };
    }

    case VALIDATE_ADDRESS_FIELDS: {
      let newState = state;
      Object.keys(ADDRESS_FIELDS).forEach(field => {
        newState = validateAddressField(newState, ADDRESS_FIELDS[field]);
      });

      return newState;
    }

    case SET_CHECKOUT_SUGGESTED_ADDRESSES: {
      const firstSuggestedAddress = `${selectedAddressId}-0`;
      return {
        ...state,
        suggestedAddresses: {
          addresses: suggestedAddresses,
          isBilling,
          selectedAddressId: firstSuggestedAddress,
          originalAddressId: selectedAddressId
        }
      };
    }

    case CHECKOUT_RECEIVE_ADDRESSES: {
      return { ...state, saved: data.addresses, loadingMessage: '' };
    }

    case RECEIVE_NEW_SHIPPING_FIELD: {
      const newAddress = { ...state.new, [fieldKey]: fieldValue };
      return { ...state, new: newAddress };
    }

    case CHECKOUT_RESET_TO_DEFAULT_STATE: {
      return defaultState;
    }

    default:
      return state;
  }
}

function updateDisplayForSuggestedAddresses(state) {
  const { suggestedAddresses: stateSuggestedAddresses } = state;
  const { addresses } = stateSuggestedAddresses;
  const showSuggestedModal = !!(addresses && addresses.length);
  const suggestedAddresses = { ...stateSuggestedAddresses, showSuggestedModal };
  return { ...state, suggestedAddresses };
}

function validateAddressField(state, fieldKey) {
  const { new: newAddr } = state;
  const key = typeof fieldKey === 'string' ? fieldKey : fieldKey.fieldName;
  const newError = pushErrorMessages(key, newAddr);
  const addressErrors = newAddr.errors ? newAddr.errors : {};
  const newAddress = { ...newAddr, errors: { ...addressErrors, [key]: newError.length ? newError : null } };
  const newState = { ...state, new: newAddress };

  // related field checks...
  switch (key) {
    case ADDRESS_FIELDS.COUNTRY_CODE.fieldName:
    {
      return validateAddressField(newState, ADDRESS_FIELDS.STATE_OR_REGION.fieldName);
    }
  }

  return newState;
}
